<template>
    <div class="layout-with-centered-max-width-child">
      <div>
        <div class="text">
          <div class="heading-container">
            <div class="font-secondary heading">About us!</div>
          </div>
          <div class="paragraph">
            <span>{{paragraphOne}}</span>
          </div>
          <div class="paragraph">
            <span>{{paragraphTwo}}</span>
          </div>
          <div class="paragraph">
            <router-link :to="privacyPageLink">
              <span>Click here to see our TOS and Privacy Policy</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    import {R_NAME_PRIVACY} from "../../services/constants"

    export default {
        name: "About",
      computed:{
          paragraphOne(){
            return `
            BimiLeap was founded by Dr. Howard Moskowitz
            –– the inventor of the science of Mind Genomics™ ––
            based on his desire to provide a free, rapid-response,
            scalable application for meaningful
            research to anyone with an idea to
            test and a desire to learn.
            `
          },
          paragraphTwo(){
            return `
              With BimiLeap, we put the opportunity for
              learning in the hands of the individual.
              Whether you’re a kindergartener in the United States,
              a research intern from Asia working to develop a new non-profit,
              a Nigerian farmer tackling irrigation challenges in your community,
              or an aspiring Australian YouTube star,
              you can use the science and
              tools powering BimiLeap to contribute ideas,
              learn from others, and inspire a global conversation
              ––all while connecting with a network
              of your fellow innovators and
              generating research (or revenue)
              for your organization or yourself.
            `
          },

          privacyPageLink(){
            return {
              name: R_NAME_PRIVACY
            }
          },
      }
    }
</script>

<style scoped lang="scss">

  @import "../../scss/main";

  .text{
    padding: 5% 20%;
  }

  .paragraph{
    padding: 3% 0;
    line-height: 120%;
  }

  .heading{
    color: $red-2;
    font-size: 20px;
    font-weight: 900;
  }

  .heading-container{
    padding: 3% 0;
  }

</style>
